import {all, call, put, select, takeLatest} from 'redux-saga/effects'
import types from '../actions/types'
import {generalError} from 'actions/index'
import {snackbarMessage} from 'actions/snackbar'
import * as partCategoryActions from 'actions/partCategoryTreeSelectField'
import {getPartCategoryTreeSelectField} from 'selectors/priceLists'

export default (api) => {

  function* loadPriceLists() {
    try {
      const params = {
        showHidden: true,
      }
      const fields = {
        default: true,
        rootCategory: true,
      }

      const response = yield call(api.priceLists.get, params, fields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(partCategoryActions.loadPriceListsSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(partCategoryActions.loadPriceListsFailure(message, code))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* loadCategories() {
    try {
      const {priceListId, categoryId, search} = yield select(state => getPartCategoryTreeSelectField(state))
      const params = {visible: true}
      if (priceListId) {
        params.pricelist = priceListId
        params.parent = categoryId // may be NULL
      } else if (search) {
        params.search = search
      } else {
        // All top-level categories
        params.parent = null
      }

      const fields = {
        default: true,
        priceList: true,
      }

      const response = yield call(api.partCategories.get, params, fields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(partCategoryActions.loadPartCategoriesSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(partCategoryActions.loadPartCategoriesFailure(message, code))
            yield put(snackbarMessage('Failed to load categories: ' + message))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* loadPartCategory({id}) {
    try {
      const response = yield call(api.partCategories.get, {id})
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(partCategoryActions.loadPartCategorySuccess(data.result[0]))
          },
          function* onFail(key, message, code) {
            yield put(partCategoryActions.loadPartCategoryFailure(message, code))
            yield put(snackbarMessage('Failed to load part category: ' + message))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  function* reloadPriceLists() {
    yield put(partCategoryActions.loadPartCategories())
    yield put(partCategoryActions.loadPriceLists())
  }

  function* watcher() {
    yield all([
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PRICE_LISTS_ATTEMPT, loadPriceLists),
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORIES_ATTEMPT, loadCategories),
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORY_ATTEMPT, loadPartCategory),
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS, reloadPriceLists),
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST, reloadPriceLists),
      takeLatest(types.PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY, reloadPriceLists),
    ])
  }

  return {
    watcher,
  }
}